// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22":"01a6f1df7f8a9c8e55ba","71":"7869e136d5fd7881759f","452":"4b9706aad0a809c03785","885":"c60e1b7e1bcf5bbb6c51","961":"73ae3d1da8098fa2c26d"}[chunkId] + ".css";
};